"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const react_router_dom_1 = require("react-router-dom");
const adyen_web_1 = __importDefault(require("@adyen/adyen-web"));
require("@adyen/adyen-web/dist/adyen.css");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const useRedirectToKeyCardActivation_1 = require("../../behaviours/useRedirectToKeyCardActivation");
const OnlineCheckinFlow_1 = require("./OnlineCheckinFlow");
const ButtonWrapper = styled_components_1.default.div `
  width: 100%;
  padding: 16px 0;
`;
// adyen keys taken from:
// https://docs.adyen.com/online-payments/web-components/localization-components#supported-languages
const adyenSupportedLocales = {
    //
    ar: {
        adyenKey: 'ar',
    },
    // chinese
    zh: {
        adyenKey: 'zh-CN', // chinese simplified
    },
    // croatian
    hr: {
        adyenKey: 'hr-HR',
    },
    // czech
    cs: {
        adyenKey: 'cs-CZ',
    },
    // danish
    da: {
        adyenKey: 'da-DK',
    },
    // dutch
    nl: {
        adyenKey: 'nl-NL',
    },
    // english
    en: {
        adyenKey: 'en-US',
    },
    // finnish
    fi: {
        adyenKey: 'fi-FI',
    },
    // french
    fr: {
        adyenKey: 'fr-FR',
    },
    // german
    de: {
        adyenKey: 'de-DE',
    },
    // greek
    el: {
        adyenKey: 'el-GR',
    },
    // hungarian
    hu: {
        adyenKey: 'hu-HU',
    },
    // italian
    it: {
        adyenKey: 'it-IT',
    },
    // japanese
    ja: {
        adyenKey: 'ja-JP',
    },
    // korean
    ko: {
        adyenKey: 'ko-KR',
    },
    // norwegian
    nn: {
        adyenKey: 'no-NO', // norwegian nynorsk
    },
    // polish
    pl: {
        adyenKey: 'pl-PL',
    },
    // portuguese
    pt: {
        adyenKey: 'pt-BR',
    },
    // romanian
    ro: {
        adyenKey: 'ro-RO',
    },
    // russian
    ru: {
        adyenKey: 'ru-RU',
    },
    // slovak
    sk: {
        adyenKey: 'sk-SK',
    },
    // slovenian
    sl: {
        adyenKey: 'sl-SI',
    },
    // spanish
    es: {
        adyenKey: 'es-ES',
    },
    // swedish
    sv: {
        adyenKey: 'sv-SE',
    },
    default: {
        adyenKey: 'en-US',
    },
};
const CreditCardPayment = ({ setDisplayStep, setDialogData, openDialog, closeDialog, openErrorDialog, openSpecificErrorDialog, onPaymentFailure, creditCardData, currentLocale, userData, fromCheckoutFlow, setHeaderText, setStatusData, adyenData, setAdyenData, kioskModeEnabled, posTerminalEnabled, stayId, baseUrl, history, }) => {
    const [env, setEnv] = (0, react_1.useState)('test');
    const [adyenPaymentFailed, setAdyenPaymentFailed] = (0, react_1.useState)(false);
    const [adyenContentLoaded, setAdyenContentLoaded] = (0, react_1.useState)(false);
    const paymentContainer = (0, react_1.useRef)(null);
    const interval = (0, react_1.useRef)(null);
    const monitorPaymentStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        openDialog();
        let intervalTimer = 1000;
        const paymentStatusToken = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        yield apiService_1.default
            .checkPaymentProgress(currentLocale, paymentStatusToken, adyenData.reference, kioskModeEnabled)
            .then((data) => {
            if (data.status === 'success') {
                if (data.nextWorkflow === 'generic_key_card') {
                    (0, useRedirectToKeyCardActivation_1.useRedirectToKeycardActivation)({ data, baseUrl, history });
                    return;
                }
                closeDialog();
                setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                setHeaderText(data.texts.title);
                setStatusData(data);
            }
            else if (data.status === 'error') {
                closeDialog();
                openSpecificErrorDialog(data.message);
            }
            else if (data.status === 'retry') {
                setDialogData({
                    text: data.texts.text,
                    showProgress: true,
                    actionText: data.texts.cancelButton,
                });
                if (data.interval) {
                    intervalTimer = data.interval;
                }
            }
        })
            .catch(() => {
            openErrorDialog();
        });
        interval.current = setInterval(() => {
            apiService_1.default
                .checkPaymentProgress(currentLocale, paymentStatusToken, adyenData.reference, kioskModeEnabled)
                .then((data) => {
                if (data.status === 'success') {
                    clearInterval(interval.current);
                    if (data.nextWorkflow === 'generic_key_card') {
                        (0, useRedirectToKeyCardActivation_1.useRedirectToKeycardActivation)({ data, baseUrl, history });
                        return;
                    }
                    closeDialog();
                    setHeaderText(data.texts.title);
                    setStatusData(data);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                }
                else if (data.status === 'error') {
                    clearInterval(interval.current);
                    closeDialog();
                    openSpecificErrorDialog(data.message);
                }
            })
                .catch(() => {
                clearInterval(interval.current);
                openErrorDialog();
            });
        }, intervalTimer);
    });
    const monitorCheckoutPaymentStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        openDialog();
        let intervalTimer = 1000;
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        yield apiService_1.default
            .checkCheckoutPaymentProgress(currentLocale, token, adyenData.reference, kioskModeEnabled)
            .then((data) => {
            if (data.status === 'success') {
                closeDialog();
                setHeaderText(data.title);
                setStatusData(data);
                setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
            }
            else if (data.status === 'error') {
                closeDialog();
                onPaymentFailure(data);
            }
            else if (data.status === 'retry') {
                setDialogData({
                    text: data.texts.text,
                    actionText: data.texts.cancelButton,
                    showProgress: true,
                });
                if (data.interval) {
                    intervalTimer = data.interval;
                }
            }
        })
            .catch(() => {
            openErrorDialog();
        });
        interval.current = setInterval(() => {
            apiService_1.default
                .checkCheckoutPaymentProgress(currentLocale, token, adyenData.reference, kioskModeEnabled)
                .then((data) => {
                if (data.status === 'success') {
                    clearInterval(interval.current);
                    closeDialog();
                    setHeaderText(data.title);
                    setStatusData(data);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                }
                else if (data.status === 'error') {
                    clearInterval(interval.current);
                    closeDialog();
                    onPaymentFailure(data);
                }
            })
                .catch(() => {
                clearInterval(interval.current);
                openErrorDialog();
            });
        }, intervalTimer);
    });
    (0, react_1.useEffect)(() => () => {
        clearInterval(interval.current);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!creditCardData) {
            return;
        }
        const adyenDataMissing = Object.keys(adyenData).length === 0;
        if (adyenDataMissing && !fromCheckoutFlow) {
            const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
            apiService_1.default
                .getAdyenConfigs(currentLocale, token, stayId, kioskModeEnabled, posTerminalEnabled ? 'pos_terminal' : 'web')
                .then((data) => {
                if (data.status === 'error') {
                    openSpecificErrorDialog(data.message);
                    return;
                }
                setEnv(data.adyenEnv);
                setAdyenData(data.result);
            })
                .catch(() => {
                openErrorDialog();
            });
            return;
        }
        if (adyenDataMissing && fromCheckoutFlow) {
            const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
            apiService_1.default
                .getCheckoutAdyenConfigs(currentLocale, token, stayId, kioskModeEnabled)
                .then((data) => {
                if (data.status === 'error') {
                    openSpecificErrorDialog(data.message);
                    return;
                }
                setEnv(data.adyenEnv);
                setAdyenData(data.result);
            })
                .catch(() => {
                openErrorDialog();
            });
            return;
        }
        const configuration = {
            // this should look like  process.env.NODE_ENV === "production" ? "live" : "test", but we need to add proper env labeling to the project
            environment: env, // choose between "live" and "text"
            clientKey: creditCardData.paymentDetails.clientKey,
            session: {
                id: adyenData.id, // Unique identifier for the payment session.
                sessionData: adyenData.sessionData, // The payment session data.
            },
            onPaymentCompleted: (result) => {
                if (result.resultCode === 'Authorised') {
                    if (!fromCheckoutFlow) {
                        monitorPaymentStatus();
                    }
                    else {
                        monitorCheckoutPaymentStatus();
                    }
                }
                else {
                    setAdyenPaymentFailed(true);
                }
            },
            onError: () => {
                openErrorDialog();
            },
            // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
            // For example, this is 3D Secure configuration for cards:
            paymentMethodsConfiguration: {
                card: {
                // hasHolderName: false,
                // holderNameRequired: true,
                // billingAddressRequired: true,
                },
            },
            locale: adyenSupportedLocales[currentLocale]
                ? adyenSupportedLocales[currentLocale].adyenKey
                : adyenSupportedLocales.default.adyenKey,
        };
        const startAdyen = () => __awaiter(void 0, void 0, void 0, function* () {
            const adyenInstance = yield (0, adyen_web_1.default)(configuration);
            if (paymentContainer.current) {
                adyenInstance.create('dropin').mount(paymentContainer.current);
            }
            setAdyenContentLoaded(true);
        });
        startAdyen();
    }, [adyenData]);
    return (react_1.default.createElement("div", null,
        !adyenContentLoaded && react_1.default.createElement(Loader_1.default, null),
        react_1.default.createElement("div", { ref: paymentContainer, id: "dropin-container" }),
        adyenPaymentFailed && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(ButtonWrapper, null,
                react_1.default.createElement(Button_1.default, { variant: "contained", size: "large", fullWidth: true, onClick: () => {
                        // temporary way to reload the adyen form
                        setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                        setTimeout(() => {
                            if (!fromCheckoutFlow) {
                                setDisplayStep(OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN);
                                return;
                            }
                            setDisplayStep(OnlineCheckinFlow_1.INVOICE_SCREEN);
                        }, 0);
                    } }, "Try submitting card again."))))));
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
    stayId: store.getValue('stayId'),
    posTerminalEnabled: store.getValue('posTerminalEnabled'),
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(CreditCardPayment));
